import { connect } from 'react-redux';

import get from 'lodash/get';
import { getFormInitialValues, getFormValues } from 'redux-form';

import CurrentUserFormComponent from './CurrentUserFormComponent';

import { UPDATE_CURRENT_PERSON } from '../../actionConstants';
import { getPMC } from '../PMC/actionCreators';
import { uploadImage } from '../Visitor/actionCreators';

import { isAdmin, isPM, loadUser } from '../../utils';
import { getUserInfo } from '../Navigation/utils';
import { findPersonEmail, findPersonPhoneNumber } from '../Person/utils';

import apiClient from '../../apiClient';

const form = 'Person';

const pmcNames = (currentUser) => {
  const pmcRoles = get(currentUser, 'pmcRoles', []);
  const properties = get(currentUser, 'properties', []);
  let pmcName = pmcRoles.reduce(
    (pmcNames, pmcRole) =>
      pmcNames.length
        ? `${pmcNames}, ${pmcRole.propertyName}`
        : `${pmcRole.propertyName}`,
    '',
  );
  pmcName += properties.reduce((pmcNames, property) => {
    const isPmc = pmcRoles.find(
      ({ propertyId }) => property.pmc === propertyId,
    );
    return isPmc
      ? pmcNames
      : pmcName.length || pmcNames.length
      ? `${pmcNames}, ${property.name}`
      : `${property.name}`;
  }, '');
  return pmcName;
};

const mapStateToProps = (state) => {
  const currentUser = get(state, 'common.currentUser');
  const pmcName = isAdmin() ? 'Carson' : pmcNames(currentUser);
  const { pmcs } = state;

  const initialValues = {};
  initialValues.firstName = get(currentUser, 'firstName');
  initialValues.lastName = get(currentUser, 'lastName');
  initialValues.email = findPersonEmail(currentUser);
  initialValues.phoneNumber = findPersonPhoneNumber(currentUser);
  initialValues.pmcName = pmcName;
  initialValues.defaultPaginationLimit = get(
    currentUser,
    'defaultPaginationLimit',
  );
  initialValues.hasPhoto = currentUser?.photo?.url;

  const formValues = getFormValues(form)(state) || {};
  const formInitialValues = getFormInitialValues(form)(state) || {};

  return {
    currentUser,
    pmcName,
    initialValues,
    formValues,
    formInitialValues,
    pmcs,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: async () => {
    const user = await getUserInfo(dispatch);
    const pmcId = get(user, 'data.pmcRoles[0].propertyId', null);
    if (isPM() && pmcId) getPMC(dispatch, pmcId);
  },
  onSubmit: (data) => {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      defaultPaginationLimit,
      images,
      photo_deleted,
    } = data;
    const postData = {
      firstName,
      lastName,
      email,
      defaultPaginationLimit,
      photo_deleted,
    };
    if (phoneNumber) {
      postData.phoneNumber = phoneNumber;
    }
    return dispatch({
      type: UPDATE_CURRENT_PERSON,
      payload: apiClient.auth.updateCurrent(postData),
      isForm: true,
      successMessage: 'Profile updated!',
      callback: async () => {
        const personId = get(loadUser(), 'id');
        const url = `persons/${personId}/photo/`;
        !photo_deleted && (await uploadImage(dispatch, images, url));
        return setTimeout(() => getUserInfo(dispatch), 1000);
      },
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CurrentUserFormComponent);
